import { useState, useEffect } from 'react';
import { supabase } from '../supabaseClient';
import DirectReportsTab from './DirectReportsTab';
import { Logo, UserChip, MenuLink } from './PageHeader';

export default function DirectReportsPage({ session, onSignOut }) {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Scoped server-side to people.leader_email = the signed-in user; empty for non-leaders.
    supabase.rpc('direct_reports_weekly', { p_weeks: 12 }).then(({ data, error: e }) => {
      if (e) setError(e.message);
      else setRows(data || []);
    });
  }, []);

  return (
    <div style={{ maxWidth: 1480, margin: '0 auto', padding: '24px 24px 60px' }}>
      <header style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 18, flexWrap: 'wrap', gap: 12 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <MenuLink />
          <Logo />
        </div>
        <UserChip session={session} onSignOut={onSignOut} />
      </header>

      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 16 }}>Direct Reports</h2>

      {error && <div style={{ padding: 60, textAlign: 'center', color: 'var(--red)' }}>Could not load: {error}</div>}
      {!error && rows === null && <div style={{ padding: 60, textAlign: 'center', color: 'var(--text3)' }}>Loading…</div>}
      {!error && rows && rows.length === 0 && (
        <div style={{ padding: 60, textAlign: 'center', color: 'var(--text3)' }}>No direct reports are linked to your account.</div>
      )}
      {!error && rows && rows.length > 0 && <DirectReportsTab rows={rows} session={session} />}
    </div>
  );
}
